<template>
  <el-dialog
    v-dialogDrag
    class="small-dialog approval-dialog"
    :title="type === 'submit' ? '一键提交' : '一键审批'"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :before-close="closeDialog"
  >
    <div class="h-full" v-loading="approvalLoading" element-loading-text="正在处理...">
      <el-table
        height="calc(100% - 50px)"
        stripe
        border
        :data="tableData"
        ref="table"
        row-key="id"
        v-loading="loading"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="50"
          align="center"
          reserve-selection
        ></el-table-column>
        <el-table-column
          label="姓名"
          prop="name"
          show-overflow-tooltip
          width="80"
        ></el-table-column>
        <el-table-column label="所属单位" prop="department" show-overflow-tooltip></el-table-column>
        <el-table-column
          label="联系电话"
          prop="phoneNumber"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="人员类别"
          prop="employeeTypeStr"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="是否特种人员" prop="isSpecialJob" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.isSpecialJob ? $t('是') : $t('否') }}</template>
        </el-table-column>
        <el-table-column label="流程状态" prop="approvalStatus" width="80">
          <template slot-scope="scope">
            <el-tag size="mini" :type="workFlowStatusTypes(scope.row.approvalStatus)">{{
              scope.row.approvalStatusStr
            }}</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div class="text-right mt-20px">
        <el-pagination
          background
          @size-change="searchList"
          @current-change="findList"
          :current-page.sync="page.pageNo"
          :page-size.sync="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[15, 30, 45, 60, 75, 90]"
          :total="page.total"
        ></el-pagination>
      </div>
    </div>
    <div slot="footer" v-if="!approvalLoading">
      <template v-if="type === 'submit'">
        <el-button type="primary" @click="submit" size="small">提交</el-button>
        <el-button @click="closeDialog" size="small">取消</el-button>
      </template>
      <template v-else>
        <el-button type="danger" @click="approval(0)" size="small">批量驳回</el-button>
        <el-button type="primary" @click="approval(1)" size="small">批量通过</el-button>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import { PeriodContractorPersonnelApi } from '@wiz-api/contractor-management'
import { map } from 'lodash'

const periodContractorPersonnelApi = new PeriodContractorPersonnelApi()
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'submit',
    },
    contractorId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      tableData: [],
      loading: false,
      selection: [],
      approvalLoading: false,
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
    workFlowStatusTypes() {
      return (val) => {
        let type = ''
        switch (val) {
          case 0:
            type = 'primary'
            break
          case 1:
            type = 'warning'
            break
          case 9:
            type = 'success'
            break
          default:
            type = 'danger'
            break
        }
        return type
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.searchList()
      }
    },
  },
  methods: {
    searchList() {
      this.page.pageNo = 1
      this.findList()
    },
    async findList() {
      this.loading = true
      const params = {
        maxResultCount: this.page.pageSize, // 每页多少条
        skipCount: (this.page.pageNo - 1) * this.page.pageSize, // 跳过多少条
        contractorId: this.contractorId,
      }
      let method = 'submitPageListQuery'
      if (this.type !== 'submit') {
        method = 'approveListQuery'
      }
      const [err, res] = await periodContractorPersonnelApi[method](params)
      if (!err) {
        this.tableData = res.items
        this.page.total = res.totalCount
      }
      this.loading = false
    },
    handleSelectionChange(selection) {
      this.selection = selection
    },
    async approval(type) {
      if (this.selection.length === 0) {
        this.$message.warning('请勾选审批数据!')
        return
      }
      this.approvalLoading = true
      const body = map(this.selection, (item) => {
        return {
          isPass: type === 1,
          approve: '',
          id: item.id,
          taskId: item.taskId,
        }
      })
      const [err, res] = await periodContractorPersonnelApi.batchApprove({
        body,
      })
      this.approvalLoading = false
      if (!err) {
        this.$message.success(
          `审批完成，成功：${res.length}条 失败：${this.selection.length - res.length}条`
        )
        this.closeDialog()
        this.$emit('finished')
      }
    },
    async submit() {
      if (this.selection.length === 0) {
        this.$message.warning('请勾选审批数据!')
        return
      }
      this.approvalLoading = true
      const [err, res] = await periodContractorPersonnelApi.batchSubmit({
        body: map(this.selection, 'id'),
      })
      this.approvalLoading = false
      if (!err) {
        this.$message.success(
          `提交完成，成功：${res.length}条 失败：${this.selection.length - res.length}条`
        )
        this.closeDialog()
        this.$emit('finished')
      }
    },
    closeDialog(done) {
      if (this.approvalLoading) {
        this.$message.warning('审批处理中，请稍等')
        return
      }
      this.tableData = []
      this.page = this.$options.data().page
      this.selection = []
      this.$refs.table.clearSelection()
      if (done) {
        done()
      } else {
        this.dialogVisible = false
      }
    },
  },
  created() {},
}
</script>

<style></style>
